import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Delete as DeleteIcon } from "@material-ui/icons"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TableRow from "@material-ui/core/TableRow"

import { Tag } from "../store/types"
import { IconButton } from "@material-ui/core"

const useStyles = makeStyles({
  table: {
    minWidth: 300,
  },
})

export interface Props {
  tags: Tag[]
  onRemoveTag(tag: Tag): void
}

const TagsTable: React.FC<Props> = ({ tags, onRemoveTag }) => {
  const classes = useStyles()

  return (
    <TableContainer>
      <Table className={classes.table} aria-label="Tags">
        <TableHead>
          <TableRow>
            <TableCell>Group</TableCell>
            <TableCell>Tag</TableCell>
            <TableCell align="right" />
          </TableRow>
        </TableHead>
        <TableBody>
          {tags.map((tag) => (
            <TableRow
              key={tag.id}
              data-qa-selector={`tag-row-${tag.group}-${tag.tag}`}
            >
              <TableCell component="th" scope="row">
                {tag.group}
              </TableCell>
              <TableCell>{tag.tag}</TableCell>
              <TableCell align="right" padding="none" size="small">
                <IconButton
                  onClick={() => onRemoveTag(tag)}
                  data-qa-selector="delete"
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default TagsTable
